import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Autocomplete, Modal, TextField } from "@mui/material";
import { PracticeNew } from "../../pages";
import { ConditionalRenderer, useLanguageTranslator } from "../../components";
import { ToastContainer } from "react-toastify";
import { toastHandler } from "../../utils/helpers";
import { toastTypesKeys } from "../../utils/constants";
import { ModalCloseIcon } from "../../@lib/icons";

const style = {
  position: "absolute",
  margin: "2% 0px",
  width: "98%",
  left: "1%",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  overflow: "auto",
  height: "90dvh",
};

export type PracticesInfoFormProps = {
  disabled?: boolean;
  data: any;
  setSelectedListPractices?: any;
  selectedListPractices?: any;
  onClickHandler?: any;
};

const PracticesInfoForm: React.FC<PracticesInfoFormProps> = ({
  data,
  setSelectedListPractices,
  selectedListPractices,
  onClickHandler,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const { translator } = useLanguageTranslator();

  const handleValueChange = (event: any, newValue: any) => {
    setSelectedValue(newValue);

    if (newValue === null) return;

    const isDuplicate = selectedListPractices.some(
      (item: any) => item?.value === newValue?.value
    );

    if (isDuplicate) {
      toastHandler("Already Selected", toastTypesKeys.error);
      return;
    }

    setSelectedListPractices([...selectedListPractices, newValue]);
  };

  function handleRemoveClick(value: string) {
    const modifiedSelectedListPractices = selectedListPractices?.filter(
      (item: any) => item.value !== value
    );
    setSelectedListPractices(modifiedSelectedListPractices);
  }

  return (
    <Stack gap={2}>
      <ToastContainer />
      <Box
        component={Paper}
        variant="outlined"
        bgcolor="grey.100"
        sx={{ minHeight: 300 ,maxHeight: 300, p: 2, overflowY:"auto" }}
      >
        <ConditionalRenderer condition={selectedListPractices?.length <= 0}>
          <Typography variant="caption">
            {translator("No practices already selected")}
          </Typography>
        </ConditionalRenderer>
        <ConditionalRenderer condition={selectedListPractices?.length > 0}>
          {selectedListPractices?.map((elem: any) => {
            return (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="caption"
                  fontWeight={"700"}
                  sx={{
                    display: "flex",
                    color: "#00AAB0",
                    marginBottom: "4px",
                    background: "#eff1f7",
                    border: "1px solid #00AAB0",
                    borderRadius: "30px",
                    p: "4px",
                    alignItems: "center",
                  }}
                >
                  {elem?.label}
                </Typography>
                <Button onClick={() => handleRemoveClick(elem?.value)}>
                  <ModalCloseIcon />
                </Button>
              </div>
            );
          })}
        </ConditionalRenderer>
      </Box>

      <Stack direction={{ md: "row" }} gap={2} alignItems={{ md: "flex-end" }}>
        <Autocomplete
          disablePortal
          options={data || []}
          sx={{ width: 300 }}
          value={selectedValue}
          onChange={handleValueChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`${translator("support.Select")} ${translator(
                "Practices"
              )}`}
            />
          )}
        />
        {/* <Button variant="contained" onClick={onClickHandler}>
          Create new practice
        </Button> */}
      </Stack>
    </Stack>
  );
};

export default PracticesInfoForm;
